import { BASEURL, Request, TRequestMethod } from "./request.ts";
import { Schema, type SchemaObject } from "./validation.ts";

export interface ESRLoginResponse{
    "session_token": string,
}

const ESRLoginResponseSchema : SchemaObject = {
    "session_token": "string",
}

export class ESRLogin extends Request<ESRLoginResponse>{
    override method : TRequestMethod = "POST";
    override responseSchema : Schema = ESRLoginResponseSchema;

    constructor (
        public username: string,
        public password: string,){
        super();
    }

    override route() : string{
        return `${BASEURL}/login`;
    }
}